import { CbarSelect2 } from './CbarSelect2.js';
window.customElements.define('cbar-select2', CbarSelect2);
//# sourceMappingURL=cbar-select2.js.map